export default __webpack_public_path__ + "static/media/img1.2ce8f7f7.webp";